<template>
    <div class="modal">
        <div class="modal-content">
            <header
                class="modal__header"
                data-test-id="modal-header"
            >
                <h2 class="modal__title">
                    <slot name="title">{{ label }}</slot>
                </h2>
            </header>

            <div
                class="modal__body"
                data-test-id="modal-body"
            >
                <pre>{{ text }}</pre>
            </div>

            <footer
                class="modal__footer"
                data-test-id="modal-footer"
            >
                <button
                    class="modal__btn modal__btn--confirm"
                    @click="confirm"
                >
                    OK
                </button>
            </footer>

            <a
                href="#"
                class="modal__btn--close"
                data-test-id="modal-close-button"
                @click.prevent="cancel"
            >
                <img
                    src="/images/close-white.svg"
                    alt="close"
                />
            </a>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        text: String,
        label: String,
        confirm: Function,
        cancel: Function,
    },
}
</script>

<style lang="scss" scoped>
.modal-content {
    background-color: #212628;
    color: #ffffff;
    font-size: 18px;
    font-family: 'Avenir Book';
    padding: 20px;
    border-radius: 5px;
    position: relative;
}

.modal__header {
    width: 100%;
    padding: 30px 0 10px 0;
    font-size: 1.25rem;
}

.modal__body {
    font-size: 15px;
    line-height: 20px;
    padding: 16px 16px 0 16px;
    height: 205px;
    width: 468px;
    overflow-y: scroll;
    border-radius: 8px;
    background-color: #333a3d;
}

.modal__footer {
    display: flex;
    justify-content: end;
    margin-top: 10px;
}

.modal__btn {
    padding: 7px 20px;
    border-radius: 20px;
    border: none;
    color: #212629;
    cursor: pointer;
    font-size: 14px;
    font-weight: 400;
    font-family: 'Avenir';
    min-width: 83px;
}

.modal__btn--confirm {
    background-color: #59c966;
}

.modal__btn--close {
    position: absolute;
    right: 15px;
    top: 15px;
}
</style>
